export { default } from './PageNotAllowed.js';